// =================================================================
// Engine: Traditional dosing module (PSD §4.2.7, §4.2.8 / TODO Task 1.4)
// =================================================================
import { err, ok } from './types';
import { PRACTICAL_INTERVALS_HR } from './constants';
/** Round a computed tau to the nearest clinically practical interval. */
export function roundToPracticalInterval(tauHr) {
    let best = PRACTICAL_INTERVALS_HR[0];
    let bestDist = Math.abs(tauHr - best);
    for (const candidate of PRACTICAL_INTERVALS_HR) {
        const dist = Math.abs(tauHr - candidate);
        if (dist < bestDist) {
            best = candidate;
            bestDist = dist;
        }
    }
    return best;
}
/**
 * Traditional loading + maintenance + interval from Kel/Vd/targets (PSD §4.2.7).
 * tau = ln(peak/trough)/kel + infusionHr; maintenance = peak × Vd × (1 − e^−kel×tau);
 * loading = peak × Vd.
 */
export function computeTraditionalRegimen(kelPerHr, vdL, targetPeak, targetTrough, infusionDurationHr) {
    if (!(kelPerHr > 0)) {
        return err('kel-must-be-positive', 'Kel must be positive for traditional dosing.', 'kelPerHr');
    }
    if (targetTrough >= targetPeak) {
        return err('inverted-targets', 'Target peak must exceed target trough.', 'targets');
    }
    const tau = Math.log(targetPeak / targetTrough) / kelPerHr + infusionDurationHr;
    if (tau <= 0) {
        return err('tau-non-positive', 'Computed interval is non-positive.', 'tau');
    }
    const tauRounded = roundToPracticalInterval(tau);
    const maintenanceDose = targetPeak * vdL * (1 - Math.exp(-kelPerHr * tauRounded));
    const loadingDose = targetPeak * vdL;
    return ok({
        loadingDoseMg: loadingDose,
        maintenanceDoseMg: maintenanceDose,
        intervalHr: tauRounded,
        tauExceeds48: tauRounded > 48,
    });
}
/**
 * Predicted steady-state peak & trough (PSD §4.2.8).
 * One-compartment intermittent IV infusion at steady state.
 */
export function predictPeakTrough(doseMg, kelPerHr, vdL, intervalHr, infusionDurationHr) {
    if (!(kelPerHr > 0)) {
        return err('kel-must-be-positive', 'Kel must be positive.', 'kelPerHr');
    }
    if (!(infusionDurationHr > 0)) {
        return err('division-by-zero', 'Infusion duration must be positive.', 'infusionDurationHr');
    }
    const k = kelPerHr;
    const t = infusionDurationHr;
    const tau = intervalHr;
    const denom = vdL * k * t;
    if (denom === 0) {
        return err('division-by-zero', 'Division by zero in peak prediction.', 'vdL');
    }
    const peak = (doseMg / denom) * ((1 - Math.exp(-k * t)) / (1 - Math.exp(-k * tau)));
    const trough = peak * Math.exp(-k * (tau - t));
    return ok({ peak, trough });
}
//# sourceMappingURL=traditional.js.map